import styled from 'styled-components';
import { ReactComponent as BullHorn } from 'assets/icons/bullhorn_sm.svg';
import { ReactComponent as Warning } from 'assets/icons/error-ag-icon.svg';
import leankeepHat from 'assets/icons/leankeep/leankeep-hat.svg';
import hexaLkpLogo from 'assets/icons/hexa-lkp-logo-o.svg';
import { medias } from 'assets/styled/tokens/medias';
import { colors } from 'assets/styled/tokens/colors';
import { Button } from 'components/Button';
export const RefereeButton = styled(Button)`
  background: #f38a00;
  color: #ffffff;
  height: 24px;
  width: 175px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-radius: 4px;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 500;
  line-height: 12px;
  padding: 0;

  @media screen and (max-width: ${medias.tablet}) {
    display: none;
  }
`;
export const StyledHeader = styled.header`
  position: relative;
  display: flex;
  padding: 1rem 3.1rem;
  border-bottom: 1px solid ${colors.lightGray};
  align-items: flex-start;
  justify-content: space-between;
  background: ${colors.pampas};
  z-index: 98;
  @media (max-width: ${medias.tablet}) {
    padding: 16px;
  }
`;

export const StyledHeaderChildren = styled.div`
  @media (max-width: ${medias.tablet}) {
    width: 100%;
  }
`;

export const StyledHeaderActions = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: stretch;
  justify-content: flex-end;

  a {
    font-size: 0.6875rem;
    color: ${colors.gray};
    font-weight: 500;
  }

  button {
    height: 100%;
    display: flex;
    span {
      margin-right: 8px;
    }
  }

  & > a {
    font-size: 13px;
    width: max-content;
    position: relative;
    display: flex;
    margin-right: 0.5rem;
    padding: 2px 5px;
    border: 1px solid #dddddd;
    border-radius: 3px;
    background-color: transparent;
    display: flex;
    align-items: center;
    padding-right: 2rem;

    &:after {
      position: absolute;
      top: 50%;
      right: 0.625rem;
      display: block;
      width: 1rem;
      height: 1rem;
      background: url(${leankeepHat}) no-repeat center/contain;
      transform: translateY(-50%);
    }
  }
`;
export const RightSideHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  //width: 590px;
  gap: 12px;

  @media (max-width: ${medias.tablet}) {
    display: none;
  }
`;
export const StyledShowUserMenu = styled.div`
  @media screen and (max-width: ${medias.desktopSm}) {
  }
`;
export const HelpCentralButton = styled.button`
  border: 1px solid #dddddd;
  font-family: Roboto;
  font-weight: 500;
  font-size: 11px;
  line-height: 100%;
  letter-spacing: 0px;
  color: #888888;
  border-radius: 4px;
  width: 120px;
  height: 24px;
  text-align: left;
  padding: 5px;
  gap: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  //background: url(${hexaLkpLogo}) no-repeat right 5px;
`;

export const AdsPopUpButton = styled.div`
  width: 105px;
  height: 24px;
  border: 1px solid #dddddd;
  font-family: Roboto;
  font-weight: 700;
  font-size: 11px;
  line-height: 100%;
  letter-spacing: 0px;
  color: #888888;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  position: relative;
`;
export const StyledBullHorn = styled(BullHorn)``;
export const StyledWarning = styled(Warning)`
  position: absolute;
  top: -6px; /* ajusta o quanto fica fora */
  left: -6px;
`;
